// @flow
import React, { Component } from 'react';
import moment from 'moment';
import { compose } from 'recompose';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/styles';
import { CircularProgress, Fade } from '@material-ui/core';
import {
    Check as CheckIcon,
    Clear as ClearIcon,
    Schedule as ScheduleIcon,
} from '@material-ui/icons';
import type { Dispatch } from 'redux';
import type { FormProps } from 'redux-form';
import type { Connector } from 'react-redux';
import type { ContextRouter } from 'react-router';
import type { TFunction } from 'react-i18next';
import fieldify from '../../../../../../components/fieldify';
import DateTimePicker from '../../../../../../components/DateTimePicker';
import { actions, selectors } from './duck';
import styles from './styles';
import type { State as RootState } from '../../../../../../redux/initialState';

type State = {
    statusTimer: ?number,
};

type OwnProps = ContextRouter & FormProps & {
    classes: Object,
    className?: string,
    t: TFunction,
};
type StateProps = {};
type Props = OwnProps & StateProps;

const DateTimePickerField = fieldify()(DateTimePicker);
const ReadOnlyField = fieldify()(
    (props: Object) => {
        const { className, placeholder, value } = props;
        const style = !value && placeholder ? { fontStyle: 'italic' } : {};
        return (
            <div className={className} style={style}>
                {value || placeholder}
            </div>
        );
    }
);

const formatDate = (value) => (value ? moment(value).format('M/D/YYYY h:mma') : '');

export class ScheduledDate extends Component<Props, State> {
    state = {
        statusTimer: null,
    };

    componentWillReceiveProps(nextProps: Props) {
        const { submitFailed, submitSucceeded } = this.props;
        const displayStatus = (!submitFailed && nextProps.submitFailed)
            || (!submitSucceeded && nextProps.submitSucceeded);

        if (displayStatus) {
            const { statusTimer } = this.state;
            clearTimeout(statusTimer);

            this.setState({
                statusTimer: setTimeout(() => this.setState({ statusTimer: null }), 1500),
            });
        }
    }

    handleBlur = () => {
        const { dirty, handleSubmit, valid } = this.props;
        if (dirty && valid) {
            handleSubmit();
        }
    };

    renderScheduledDate() {
        const { classes, disabled, readOnly } = this.props;
        return readOnly.includes('scheduledDate')
            ? (
                <Field
                  name="scheduledDate"
                  format={formatDate}
                  component={ReadOnlyField}
                  className={classes.readOnly}
                  placeholder="unscheduled"
                />
            )
            : (
                <Field
                  name="scheduledDate"
                  component={DateTimePickerField}
                  classes={{ dateInput: classes.dateInput }}
                  disabled={disabled.includes('scheduledDate')}
                  placeholder="unscheduled"
                  onBlur={this.handleBlur}
                />
            );
    }

    render() {
        const { classes, handleSubmit, submitSucceeded, submitting, t } = this.props;
        const { statusTimer } = this.state;
        return (
            <form className={classes.container} onSubmit={handleSubmit}>
                <ScheduleIcon className={classes.icon} />
                <span className={classes.label}>{t('ticketDetail.summary.scheduledDate')}</span>
                {this.renderScheduledDate()}
                {submitting
                    ? <CircularProgress size={18} thickness={4} />
                    : (
                        <Fade in={!!statusTimer} timeout={{ exit: 250 }}>
                            {submitSucceeded
                                ? <CheckIcon className={classes.successIcon} />
                                : <ClearIcon className={classes.errorIcon} />
                            }
                        </Fade>
                    )
                }
            </form>
        );
    }
}

const mapStateToProps = (state: RootState, props: OwnProps): StateProps => ({
    disabled: selectors.getDisabled(state, props),
    initialValues: selectors.getInitialValues(state, props),
    readOnly: selectors.getReadOnly(state, props),
});

const connector: Connector<OwnProps, Props> = connect(mapStateToProps);
const enhance = compose(
    withStyles(styles, { name: 'ScheduledDate' }),
    withTranslation(),
    connector,
    reduxForm({
        form: 'scheduledDate',
        enableReinitialize: true,
        destroyOnUnmount: false,
        onSubmit: (values: Object, dispatch: Dispatch<any>, props: Props): Promise<any> => dispatch(actions.submit(values, props)),
    })
);

export default enhance(ScheduledDate);
